import React, { Component } from 'react';
import './c3.css';
import './App.css';
import Moment from 'react-moment';

import { Alert,Pagination,Button,OverlayTrigger,Tooltip } from 'react-bootstrap';
import Header from '../Header/Header.jsx';
import ServiceStatus from '../ServiceStatus/ServiceStatus.jsx';
import StatusAnnouncement from '../StatusAnnouncement/StatusAnnouncement.jsx';
import MonitorApi from '../../utils/MonitorApi';
import C3Chart from 'react-c3js';

var Translate   = require('react-translate-component');
var StateActions = require('../../actions/StateActions');
var StateStore = require('../../stores/StateStore');
var TrendStore = require('../../stores/TrendStore');
var AnnouncementStore = require('../../stores/AnnouncementStore');
var serviceStatesMap = {normal:{color:'success',icon:'icon-check-circle'},maintenance:{color:'maintenance',icon:'icon-message-circle'},warning:{color:'warning',icon:'icon-cloud-lightning'},critical:{color:'danger',icon:'icon-alert-triangle'}};

//var title = {text:'watchdog.title.text',info:'watchdog.title.info'}

const tooltipResponseTime = (
    <Tooltip id="tooltip"><Translate component="span" content="watchdog.statistics.responsetime.title" /></Tooltip>
);
const trentAxis = {x: {type: 'timeseries', tick: {count:5,fit:true,format: '%H:%M'}}, y : {tick: {count:5,fit:true,format: function (d) { return Math.round(d) + 'ms'; }}}}
const size = {height:160};
const point ={show:true};
const legend={show:false};



function init(){
  MonitorApi.init().then(function(){
    MonitorApi.loadData();
  });
}

function getServiceState() {
  var state = StateStore.getState();
  return {
    services: state.services,
    message: state.message,
    messageState: state.messageState
  }
}

function getAnnouncementState(){
  var announcements = AnnouncementStore.getAnnouncements();
  return {
    announcements: announcements.items,
    announcementsCount:announcements.count
  }
}

function getTrendState(){
  var trend = TrendStore.getTrend();
  var dates = [];
  var values = [];
  var sum = 0;
  var max = trend.dataPoints[0].value;
  var min = trend.dataPoints[0].value;
  dates.push('x');
  values.push('response time');
  for(var i = 0; i < trend.dataPoints.length; i++){
    dates.push(new Date(trend.dataPoints[i].time));
    values.push(Math.round(trend.dataPoints[i].value));
    sum += trend.dataPoints[i].value;
    if(trend.dataPoints[i].value > max){
      max = trend.dataPoints[i].value;
    }
    if(trend.dataPoints[i].value < min){
      min = trend.dataPoints[i].value;
    }
  }
  var avg = sum / values.length;
  trentAxis.y.max = max;
  trentAxis.y.min = min;
  return {trentCurrentValue:Math.round(trend.currentValue),
          trentAvgValue:Math.round(avg),
          trentData:{x:'x',columns:[dates,values],types: {'response time': 'area'}},
          today:new Date()
  };
}
class App extends Component {

  constructor(props) {
    init();
    super(props);
    this.isAuthorized = MonitorApi.isAuthorized();
    this.state = {editMode:false,trentData:{x:'x',columns:[]}};
    this.onChangeStateStore = this.onChangeStateStore.bind(this);
    this.onChangeAnnouncementStore = this.onChangeAnnouncementStore.bind(this);
    this.onChangeTrendStore = this.onChangeTrendStore.bind(this);
    this.renderServices = this.renderServices.bind(this);
    this.renderMessageState = this.renderMessageState.bind(this);
    this.getOverviewState = this.getOverviewState.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.saveMessage = this.saveMessage.bind(this);
    this.addAnnouncement = this.addAnnouncement.bind(this);
    this.editModeMessage = this.editModeMessage.bind(this);
  }

  // Add change listeners to stores
  componentDidMount() {
    StateStore.addChangeListener(this.onChangeStateStore);
    TrendStore.addChangeListener(this.onChangeTrendStore);
    AnnouncementStore.addChangeListener(this.onChangeAnnouncementStore);
  }

  // Remove change listers from stores
  componentWillUnmount() {
    StateStore.removeChangeListener(this.onChangeStateStore);
    TrendStore.removeChangeListener(this.onChangeTrendStore);
    AnnouncementStore.addChangeListener(this.onChangeAnnouncementStore);
  }

  editModeMessage(){
    this.setState({editMode:!this.state.editMode});
  }

  getOverviewState(services) {
    var state = 'normal';
    Object.keys(services).forEach(function (key) {
      if(services[key].state !== 'normal'){
        state = services[key].state;
      }
    });
    return state;
  }

  deleteMessage() {
    StateActions.deleteMessage();
  }

  saveMessage(){
    StateActions.editMessage({message:this.state.message, messageState: this.state.messageState})
  }

  renderMessageState() {
    if(this.state.messageState) {
      return (
        <Alert bsStyle={serviceStatesMap[this.state.messageState].color}>
          <div className='col-xs-12'>
            {this.isAuthorized?
              <div className="button_float_right">
                <Button onClick={this.deleteMessage}  className='centerAll no_style delete_button'><span className="icon_button icon-trash-2"></span> </Button>
                <Button onClick={this.editModeMessage}
                        className='centerAll no_style edit_button'><span className="icon_button icon-edit-2"></span>
                </Button>
              </div>
              :undefined
            }
            <div className="centerAll">
              <i className={'icon_alert ' + serviceStatesMap[this.state.messageState].icon}></i>
              { this.state.message ?
              <p className='text_alert'><strong></strong><span>{this.state.message}</span></p>:
              <p className='text_alert'><Translate component='strong' content={'watchdog.alert.'+this.state.messageState+'.title'} /> <Translate component='span' content={'watchdog.alert.'+this.state.messageState+'.info'} /></p>
              }
            </div>
          </div>
        </Alert>
      );
    } else {
      if(this.state.services){
        this.messageState = this.getOverviewState(this.state.services);

        return(
          <div>
            <Alert bsStyle={serviceStatesMap[ this.messageState].color}>
              <div className='col-xs-12'>
                {this.isAuthorized?
                  <div className="button_float_right">
                    <Button onClick={this.editModeMessage}
                            className='centerAll no_style edit_button'><span className="icon_button icon-edit-2"></span>
                    </Button>
                  </div>
                  :undefined
                }
                <div className="centerAll">
                  <i className={'icon_alert ' + serviceStatesMap[ this.messageState].icon}></i>
                  <p className='text_alert'><Translate component='strong' content={'watchdog.alert.'+ this.messageState+'.title'} /> <Translate component='span' content={'watchdog.alert.'+ this.messageState+'.info'} /></p>
                </div>
              </div>
            </Alert>
          </div>

      );
      } else {
        return('');
      }
    }
  }

  onChangeStateStore() {
    this.setState({editMode:false});
    this.setState(getServiceState());
  }

  onChangeAnnouncementStore() {
    this.setState(getAnnouncementState());
  }

  onChangeTrendStore() {
    this.setState(getTrendState());
  }

  renderServices(services){
    var serviceVisual = [];
    Object.keys(services).forEach(function (key) {
      services[key].name = key;
      serviceVisual.push(<ServiceStatus key={key} service={services[key]} />);
    });
    return serviceVisual;
  }

  updateMessageStatus(newState){
    this.setState({messageState:newState.target.value});
    this.forceUpdate();
  };

  handleMessageChange(e){
    this.setState({message: e.target.value});
    this.forceUpdate();
  }

  generatePossibleStates(){
    var serviceVisualEdit = [];
    var msgState = this.state.messageState;
    var updateMessageStatus = this.updateMessageStatus.bind(this);
    Object.keys(serviceStatesMap).forEach(function (key) {
      serviceVisualEdit.push(
        <div className='col-xs-3' key={key} >
          <div className='centerAll'>
            <input onClick={updateMessageStatus}
                   type='button'
                   value={key}
                   className={'no_style service_status clickable centerAll ' + (serviceStatesMap[key].color+ '_status ') + (msgState === key ? 'selected' : undefined)} readOnly>
            </input>
          </div>
        </div>);
    });
    return serviceVisualEdit;
  }

  addAnnouncement(){
    var tempService = this.state.announcements;
    tempService.push({date:new Date(), title:'Announcement',services:[]});
    this.setState({announcements: tempService});
  }

  render() {

     const tooltipAvgResponseTime = (<Tooltip id="tooltip"><Translate component="span" content="watchdog.statistics.responsetime.average" /><span> {this.state.trentAvgValue}ms</span></Tooltip>);
    const tooltipDateResponseTime = (<Tooltip id="tooltip"><Moment format="lll">{this.state.today}</Moment></Tooltip>);

    const frameStyle = {
    }
    return (
      <div style={frameStyle}>
        <Header />
        <div className="body_information">
          { /*<div className='col-xs-12 page_title'>
            <Translate component='h2' content={title.text} />
            <p><Translate component='i' content={title.info} /></p>
          </div> */}
            {
              this.isAuthorized ?
                <div className='col-xs-12 col-sm-8 col-sm-offset-2'>
                  {this.renderMessageState()}
                  {this.state.editMode?
                    <div className='message_edit_block col-xs-8 col-xs-offset-2'>
                      <Translate component='h3' content='watchdog.alert.editMessage.title' />
                      <div className='col-xs-12 row-flex row-flex-wrap edit_block'>
                        <div className='col-xs-4 verticalCenter'>
                          <Translate component='p' className='noMargin' content='watchdog.alert.editMessage.state' />
                        </div>
                        <div className='col-xs-8'>
                          {this.generatePossibleStates()}
                        </div>
                      </div>
                      <div className='col-xs-12 row-flex row-flex-wrap edit_block'>
                        <div className='col-xs-4 verticalCenter'>
                          <Translate component='p' className='noMargin' content='watchdog.alert.editMessage.message' />
                        </div>
                        <div className='col-xs-8'>
                          <input type='text'
                                 className='form-control'
                                 onChange={this.handleMessageChange} />
                        </div>
                      </div>
                      <div>
                        <Button onClick={this.saveMessage}
                                className='no_style save_button col-xs-6 col-xs-offset-3'> <Translate component='span' content={'watchdog.entitySave'} />
                        </Button>
                      </div>
                    </div>
                    : undefined
                    }
                </div>
                :<div className='col-xs-12 col-sm-8 col-sm-offset-2'>{this.renderMessageState()}</div>
            }
          <div className='col-xs-12'>
            { this.state.services ? this.renderServices(this.state.services) : <Translate component='p' className='centerAll' content='watchdog.services.notavailable' /> }
              <div className="col-xs-12 col-sm-6 col-md-3">
                <div id="chart" className="trend_block">
                  <div className="col-xs-12">
                    <OverlayTrigger placement="right" overlay={tooltipResponseTime}>
                      <Translate component='p' className='status_block_title text_trend_block col-xs-6 render_text_inside_div' content='watchdog.statistics.responsetime.title' />
                    </OverlayTrigger>
                    <p className="text_right_trend_block col-xs-6 text_trend_block status_block_title">{this.state.trentCurrentValue}ms</p>
                    <OverlayTrigger placement="right" overlay={tooltipAvgResponseTime} >
                      <p className='text_trend_block col-xs-6 render_text_inside_div'>
                        <Translate component='span' className='text_trend_block status_block_text render_text_inside_div' content='watchdog.statistics.responsetime.average' />
                        <span className='text_trend_block status_block_text'> {this.state.trentAvgValue}ms</span>
                      </p>
                    </OverlayTrigger>
                  <OverlayTrigger placement="left" overlay={tooltipDateResponseTime} >
                    <Moment className="text_right_trend_block col-xs-6 text_trend_block status_block_text render_text_inside_div" format="lll">{this.state.today}</Moment>
                  </OverlayTrigger>
                  </div>
                  <div className="centerAll col-xs-12">
                    <div className="chart_trend_block">
                      <C3Chart data={this.state.trentData} axis={trentAxis} size={size} point={point} legend={legend}/>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div className='status_history_block col-xs-12'>
            <Translate component='h3' className='sub_title' content='watchdog.statushistory.title' />
            <div className='col-xs-12 col-sm-10 col-sm-offset-1'>
              { this.state.announcements ?
                this.state.announcements.map(function(announcement) {
                  return <StatusAnnouncement key={announcement.id ? announcement.id : 'newAnnouncement'} announcement={announcement} />
                }) : undefined
              }
              {this.state.announcementsCount < 1 ? <Translate component='strong' className='sub_title' content='watchdog.statushistory.noAnnouncements' /> : undefined}
              {
                this.isAuthorized ?
                  <div className='col-xs-12 marginToTop'>
                    <Button onClick={this.addAnnouncement}
                            className='no_style save_button col-xs-6 col-xs-offset-3'> <Translate component='span' content={'watchdog.statushistory.addAnnouncement'} />
                    </Button>
                  </div>
                  : undefined
              }
            </div>

            { this.state.announcementsCount && this.state.announcementsCount > 10 ?
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                items={this.announcementsCount}
                maxButtons={5}
                activePage={this.state.activePage}
                onSelect={this.handleSelect} /> : undefined
            }
          </div>
        </div>
        <footer className="centerAll">
          <p className="noMargin"> &copy; 2010 - {new Date().getFullYear()} Onsophic, All Rights Reserved.</p>
        </footer>
      </div>
    );
  }
}

export default App;


/** WEBPACK FOOTER **
 ** ./src/components/App/App.jsx
 **/